(() => {
  function init(root) {
    if (root.dataset.madoInitialized === 'true') return;
    root.dataset.madoInitialized = 'true';
    const rows = [...root.querySelectorAll('[data-mado-playlist]')];
    const tabs = [...root.querySelectorAll('[data-mado-tab]')];
    const search = root.querySelector('[data-mado-search]');
    const back = root.querySelector('[data-mado-back]');
    const empty = root.querySelector('[data-mado-empty]');
    const dialog = root.querySelector('[data-mado-dialog]');
    const player = root.querySelector('[data-mado-player]');
    const title = root.querySelector('[data-mado-dialog-title]');
    const selected = new URL(window.location.href).searchParams.get('playlist');
    const active = rows.some(r => r.dataset.madoPlaylist === selected) ? selected : 'all';

    function addSyncedVideo(row, item) {
      if (!item || !/^[a-zA-Z0-9_-]{11}$/.test(item.id)) return;
      // Ne pas dupliquer les vidéos déjà ajoutées manuellement.
      if (row.querySelector('[data-video-id="' + item.id + '"]')) return;
      const article = document.createElement('article');
      article.className = 'mado-tutorials__video';
      article.setAttribute('data-mado-video', '');
      article.dataset.search = (item.title || '').toLocaleLowerCase();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mado-tutorials__video-button';
      button.setAttribute('data-mado-open', '');
      button.dataset.videoId = item.id;
      button.dataset.videoTitle = item.title || 'Tutoriel Madolaine';
      button.setAttribute('aria-label', 'Lire : ' + button.dataset.videoTitle);
      const thumb = document.createElement('span');
      thumb.className = 'mado-tutorials__thumb';
      const img = document.createElement('img');
      img.src = /^https:\/\//.test(item.thumbnail || '') ? item.thumbnail : 'https://i.ytimg.com/vi/' + item.id + '/hqdefault.jpg';
      img.loading = 'lazy';
      img.alt = item.title || '';
      img.width = 480;
      img.height = 270;
      const play = document.createElement('span');
      play.className = 'mado-tutorials__play';
      play.setAttribute('aria-hidden', 'true');
      play.textContent = '▶';
      thumb.append(img, play);
      const name = document.createElement('span');
      name.className = 'mado-tutorials__video-title';
      name.textContent = button.dataset.videoTitle;
      button.append(thumb, name);
      article.append(button);
      row.querySelector('.mado-tutorials__track').append(article);
    }

    function playlistId(raw) {
      if (!raw) return '';
      const match = raw.match(/(?:[?&]list=|^)([a-zA-Z0-9_-]{10,})/);
      return match ? match[1] : '';
    }

    async function syncPlaylists() {
      const endpoint = root.dataset.madoFeedUrl.trim();
      if (!endpoint || !/^https:\/\//i.test(endpoint)) return;
      const targets = rows.map(row => ({row, id: playlistId(row.dataset.madoYoutubePlaylist)})).filter(x => x.id);
      await Promise.all(targets.map(async ({row, id}) => {
        try {
          const url = new URL(endpoint);
          url.searchParams.set('playlist', id);
          const result = await fetch(url.href, {mode: 'cors'});
          if (!result.ok) throw new Error('Erreur HTTP ' + result.status);
          const data = await result.json();
          if (!Array.isArray(data.videos)) throw new Error('Réponse JSON inattendue');
          data.videos.forEach(item => addSyncedVideo(row, item));
        } catch (error) {
          console.warn('Madolaine : playlist YouTube non chargée', id, error);
        }
      }));
      update();
    }

    function update() {
      const query = search.value.trim().toLocaleLowerCase();
      let visibleCount = 0;
      rows.forEach(row => {
        const rowActive = active === 'all' || row.dataset.madoPlaylist === active;
        let matches = 0;
        row.querySelectorAll('[data-mado-video]').forEach(card => {
          const match = !query || card.dataset.search.toLocaleLowerCase().includes(query);
          card.hidden = !match;
          if (match) matches++;
        });
        row.hidden = !rowActive || matches === 0;
        if (rowActive) visibleCount += matches;
        row.classList.toggle('mado-tutorials__playlist--all', active !== 'all' || Boolean(query));
        const viewAll = row.querySelector('[data-mado-view-all]');
        const prev = row.querySelector('[data-mado-prev]');
        const next = row.querySelector('[data-mado-next]');
        viewAll.hidden = active !== 'all';
        prev.hidden = next.hidden = active !== 'all' || Boolean(query);
      });
      empty.hidden = visibleCount > 0;
    }
    tabs.forEach(tab => { const selectedTab = tab.dataset.madoTab === active; tab.classList.toggle('is-active', selectedTab); if (selectedTab) tab.setAttribute('aria-current','page'); });
    back.hidden = active === 'all';
    search.addEventListener('input', update);
    rows.forEach(row => {
      const viewport = row.querySelector('[data-mado-viewport]');
      row.querySelector('[data-mado-prev]').addEventListener('click', () => viewport.scrollBy({left: -viewport.clientWidth * .85, behavior:'smooth'}));
      row.querySelector('[data-mado-next]').addEventListener('click', () => viewport.scrollBy({left: viewport.clientWidth * .85, behavior:'smooth'}));
    });
    function closeVideo() { player.replaceChildren(); if (dialog.open) dialog.close(); }
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-mado-open]');
      if (!button || !root.contains(button)) return;
      closeVideo();
      title.textContent = button.dataset.videoTitle;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(button.dataset.videoId) + '?autoplay=1&rel=0';
      iframe.title = button.dataset.videoTitle;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      player.appendChild(iframe);
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open','');
    });
    root.querySelector('[data-mado-close]').addEventListener('click', closeVideo);
    dialog.addEventListener('close', () => player.replaceChildren());
    dialog.addEventListener('click', e => { if (e.target === dialog) closeVideo(); });
    update();
    syncPlaylists();
  }
  function boot(container = document) { container.querySelectorAll('[data-mado-library]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
